const recipeData = [
  {
    id: "0001",
    name: "Fish Tacos",
    description: "These delicious Tilapia fish tacos are perfect for a summer lunch",
    tags: ["Lunch", "Healthy"],
    image:
      "https://images.unsplash.com/photo-1512838243191-e81e8f66f1fd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80",
    steps: [
      {
        ingredients: [
          { qty: "4", name: "Tilapia Fillets" },
          { qty: "4", name: "Corn Tortillas" },
        ],
        instructions: "Cook your tilapia and place it on your tacos",
      },
      {
        ingredients: [{ qty: "1", name: "Cilantro" }],
        instructions: "Place some cilantro on your tacos and eat them",
      },
    ],
  },
  {
    id: "0002",
    name: "Rye Bread",
    description: "Fresh bread, nothing better",
    tags: ["Baking"],
    image:
      "https://images.unsplash.com/photo-1509440159596-0249088772ff?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=900&q=60",
    steps: [
      {
        ingredients: [
          { qty: "4", name: "Flour" },
          { qty: "1", name: "Yeast" },
          { qty: "1", name: "Salt" },
          { qty: "1", name: "Sugar" },
        ],
        instructions: "Mix your dry ingredients",
      },
      {
        ingredients: [
          { qty: "1", name: "Milk" },
          { qty: "1", name: "Butter" },
        ],
        instructions:
          "Make a well in your flour and thoroughly mix in your milk and melted butter. Knead for 10 minutes.",
      },
      {
        ingredients: [],
        instructions:
          "Let rise for 1 hour. Bake at 425 F for 10 minutes, lower the temperature to 375 F, and bake for an additional 20 minutes.",
      },
    ],
  },
  {
    id: "0003",
    name: "Superfood Bowl",
    description: "A perfect lunchtime energy boost",
    tags: ["Lunch", "Healthy"],
    image:
      "https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1296&q=60",
    steps: [
      {
        ingredients: [
          { qty: "2", name: "Hard-boiled eggs" },
          { qty: "1", name: "Avocado" },
          { qty: "3", name: "Tomatos" },
          { qty: "1", name: "Mixed greens" },
        ],
        instructions: "Mix it all together and enjoy",
      },
    ],
  },
  {
    id: "0004",
    name: "Homemade Lemonade",
    description: "Perfect for a hot summer afternoon",
    tags: ["Drink"],
    image:
      "https://images.unsplash.com/photo-1414450397866-85f90db48714?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80",
    steps: [
      {
        ingredients: [
          { qty: "1", name: "Water" },
          { qty: "4", name: "Lemons" },
        ],
        instructions: "Juice your lemons and mix with one gallon of water",
      },
      {
        ingredients: [{ qty: "1", name: "Sugar" }],
        instructions: "Add sugar to taste",
      },
    ],
  },
  {
    id: "0005",
    name: "Sugar Cookies",
    description: "A special holiday treat",
    tags: ["Dessert", "Baking"],
    image:
      "https://images.unsplash.com/photo-1576091191257-fb6b1b9ad251?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1296&q=60",
    steps: [
      {
        ingredients: [
          { qty: "1", name: "Flour" },
          { qty: "2", name: "Powdered Sugar" },
        ],
        instructions: "Make cookies",
      },
      {
        ingredients: [{ qty: "1", name: "Frosting" }],
        instructions: "Decorate them",
      },
    ],
  },
  {
    id: "0006",
    name: "Belgian Waffles",
    description: "Yummy belgian waffles",
    tags: ["Baking", "Breakfast"],
    image:
      "https://images.unsplash.com/photo-1481931843671-c93039a19cc1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1296&q=60",
    steps: [
      {
        ingredients: [
          { qty: "4", name: "Flour" },
          { qty: "1", name: "Cinnamon" },
          { qty: "2", name: "Eggs" },
        ],
        instructions: "Make waffles. ",
      },
    ],
  },
]

export default recipeData

export const calendarRecipes = {
  January: {
    "1": {
      b: null,
      l: null,
      d: null,
    },
    "2": {
      b: null,
      l: null,
      d: null,
    },
    "3": {
      b: null,
      l: null,
      d: null,
    },
    "4": {
      b: null,
      l: null,
      d: null,
    },
    "5": {
      b: null,
      l: null,
      d: null,
    },
    "6": {
      b: null,
      l: null,
      d: null,
    },
    "7": {
      b: null,
      l: null,
      d: null,
    },
    "8": {
      b: null,
      l: null,
      d: null,
    },
    "9": {
      b: null,
      l: null,
      d: null,
    },
    "10": {
      b: null,
      l: null,
      d: null,
    },
    "11": {
      b: null,
      l: null,
      d: null,
    },
    "12": {
      b: null,
      l: null,
      d: null,
    },
    "13": {
      b: null,
      l: null,
      d: null,
    },
    "14": {
      b: null,
      l: null,
      d: null,
    },
    "15": {
      b: null,
      l: null,
      d: null,
    },
    "16": {
      b: null,
      l: null,
      d: null,
    },
    "17": {
      b: null,
      l: null,
      d: null,
    },
    "18": {
      b: null,
      l: null,
      d: null,
    },
    "19": {
      b: null,
      l: null,
      d: null,
    },
    "20": {
      b: null,
      l: null,
      d: null,
    },
    "21": {
      b: null,
      l: null,
      d: null,
    },
    "22": {
      b: null,
      l: null,
      d: null,
    },
    "23": {
      b: null,
      l: null,
      d: null,
    },
    "24": {
      b: null,
      l: null,
      d: null,
    },
    "25": {
      b: null,
      l: null,
      d: null,
    },
    "26": {
      b: null,
      l: null,
      d: null,
    },
    "27": {
      b: null,
      l: null,
      d: null,
    },
    "28": {
      b: null,
      l: null,
      d: null,
    },
    "29": {
      b: null,
      l: null,
      d: null,
    },
    "30": {
      b: null,
      l: null,
      d: null,
    },
    "31": {
      b: null,
      l: null,
      d: null,
    },
  },
  February: {
    "1": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "2": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "3": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "4": {
      b: null,
      l: null,
      d: null,
    },
    "5": {
      b: null,
      l: null,
      d: null,
    },
    "6": {
      b: null,
      l: null,
      d: null,
    },
    "7": {
      b: null,
      l: null,
      d: null,
    },
    "8": {
      b: null,
      l: null,
      d: null,
    },
    "9": {
      b: null,
      l: null,
      d: null,
    },
    "10": {
      b: null,
      l: null,
      d: null,
    },
    "11": {
      b: null,
      l: null,
      d: null,
    },
    "12": {
      b: null,
      l: null,
      d: null,
    },
    "13": {
      b: null,
      l: null,
      d: null,
    },
    "14": {
      b: null,
      l: null,
      d: null,
    },
    "15": {
      b: null,
      l: null,
      d: null,
    },
    "16": {
      b: null,
      l: null,
      d: null,
    },
    "17": {
      b: null,
      l: null,
      d: null,
    },
    "18": {
      b: null,
      l: null,
      d: null,
    },
    "19": {
      b: null,
      l: null,
      d: null,
    },
    "20": {
      b: null,
      l: null,
      d: null,
    },
    "21": {
      b: null,
      l: null,
      d: null,
    },
    "22": {
      b: null,
      l: null,
      d: null,
    },
    "23": {
      b: null,
      l: null,
      d: null,
    },
    "24": {
      b: null,
      l: null,
      d: null,
    },
    "25": {
      b: null,
      l: null,
      d: null,
    },
    "26": {
      b: null,
      l: null,
      d: null,
    },
    "27": {
      b: null,
      l: null,
      d: null,
    },
    "28": {
      b: null,
      l: null,
      d: null,
    },
    "29": {
      b: null,
      l: null,
      d: null,
    },
  },
  March: {
    "1": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "2": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "3": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "4": {
      b: null,
      l: null,
      d: null,
    },
    "5": {
      b: null,
      l: null,
      d: null,
    },
    "6": {
      b: null,
      l: null,
      d: null,
    },
    "7": {
      b: null,
      l: null,
      d: null,
    },
    "8": {
      b: null,
      l: null,
      d: null,
    },
    "9": {
      b: null,
      l: null,
      d: null,
    },
    "10": {
      b: null,
      l: null,
      d: null,
    },
    "11": {
      b: null,
      l: null,
      d: null,
    },
    "12": {
      b: null,
      l: null,
      d: null,
    },
    "13": {
      b: null,
      l: null,
      d: null,
    },
    "14": {
      b: null,
      l: null,
      d: null,
    },
    "15": {
      b: null,
      l: null,
      d: null,
    },
    "16": {
      b: null,
      l: null,
      d: null,
    },
    "17": {
      b: null,
      l: null,
      d: null,
    },
    "18": {
      b: null,
      l: null,
      d: null,
    },
    "19": {
      b: null,
      l: null,
      d: null,
    },
    "20": {
      b: null,
      l: null,
      d: null,
    },
    "21": {
      b: null,
      l: null,
      d: null,
    },
    "22": {
      b: null,
      l: null,
      d: null,
    },
    "23": {
      b: null,
      l: null,
      d: null,
    },
    "24": {
      b: null,
      l: null,
      d: null,
    },
    "25": {
      b: null,
      l: null,
      d: null,
    },
    "26": {
      b: null,
      l: null,
      d: null,
    },
    "27": {
      b: null,
      l: null,
      d: null,
    },
    "28": {
      b: null,
      l: null,
      d: null,
    },
    "29": {
      b: null,
      l: null,
      d: null,
    }
  },
  April: {
    "1": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "2": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "3": {
      b: recipeData[0],
      l: null,
      d: null,
    },
    "4": {
      b: null,
      l: null,
      d: null,
    },
    "5": {
      b: null,
      l: null,
      d: null,
    },
    "6": {
      b: null,
      l: null,
      d: null,
    },
    "7": {
      b: null,
      l: null,
      d: null,
    },
    "8": {
      b: null,
      l: null,
      d: null,
    },
    "9": {
      b: null,
      l: null,
      d: null,
    },
    "10": {
      b: null,
      l: null,
      d: null,
    },
    "11": {
      b: null,
      l: null,
      d: null,
    },
    "12": {
      b: null,
      l: null,
      d: null,
    },
    "13": {
      b: null,
      l: null,
      d: null,
    },
    "14": {
      b: null,
      l: null,
      d: null,
    },
    "15": {
      b: null,
      l: null,
      d: null,
    },
    "16": {
      b: null,
      l: null,
      d: null,
    },
    "17": {
      b: null,
      l: null,
      d: null,
    },
    "18": {
      b: null,
      l: null,
      d: null,
    },
    "19": {
      b: null,
      l: null,
      d: null,
    },
    "20": {
      b: null,
      l: null,
      d: null,
    },
    "21": {
      b: null,
      l: null,
      d: null,
    },
    "22": {
      b: null,
      l: null,
      d: null,
    },
    "23": {
      b: null,
      l: null,
      d: null,
    },
    "24": {
      b: null,
      l: null,
      d: null,
    },
    "25": {
      b: null,
      l: null,
      d: null,
    },
    "26": {
      b: null,
      l: null,
      d: null,
    },
    "27": {
      b: null,
      l: null,
      d: null,
    },
    "28": {
      b: null,
      l: null,
      d: null,
    },
    "29": {
      b: null,
      l: null,
      d: null,
    }
  }
}
